import { useMemo } from 'react';

import { useUrlFilterParams } from 'common/hooks/useUrlFilterParams';
import { skillGroupsFilter, skillsFilter } from 'common/utils/drawerFilters';
import {
    filtersToBase64String,
    filtersToQueryParams,
} from 'common/utils/filter';
import { IFilterFormItem, TFilterFormValues } from 'common/types';
import { ISkillFilterValues } from 'skill/types';

export const useSkillReportFilter = (filterParamsInUrl = true) => {
    const { filterParams, setFilterParam } = useUrlFilterParams(
        'skill',
        filterParamsInUrl
    );

    const filters = [
        skillGroupsFilter(
            'skillReportMatrixFilters.skillGroups',
            'skillGroups',
            'skillGroups'
        ),
        skillsFilter(),
    ] as IFilterFormItem[];

    const searchQueryParam = filterParams.q || '';

    const handleSearch = (searchValue: string) => {
        setFilterParam('q', searchValue);
    };

    const handleFilterChange = (values?: TFilterFormValues) => {
        const filterString = filtersToBase64String(filters, values);

        setFilterParam('filters', filterString);
    };

    const selectedFilterParams = filterParams.filters;

    const selectedFilters = useMemo(() => {
        if (!selectedFilterParams) return {};

        try {
            return JSON.parse(window.atob(selectedFilterParams));
        } catch {
            return {};
        }
    }, [selectedFilterParams]);

    const filterValuesForQuery = useMemo(() => {
        const filterValues = filtersToQueryParams<ISkillFilterValues>(
            filters,
            selectedFilters
        );

        const { skillGroups, skillIds, ...other } = filterValues;

        const values = { ...other };

        if (skillGroups) values.groupIds = skillGroups;
        if (skillIds) values.ids = skillIds;

        return values;
    }, [selectedFilters]);

    return {
        filters,
        selectedFilters,
        filterValues: { ...selectedFilters, q: searchQueryParam },
        filterValuesForQuery: { ...filterValuesForQuery, q: searchQueryParam },
        handleSearch,
        handleFilterChange,
    };
};
